import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { seoApi } from "../../api/endpoints";
import type { SeoUpsert } from "@endeks/shared";

export function useSeo(path: string, locale: string) {
  return useQuery({
    queryKey: ["seo", path, locale],
    queryFn: () => seoApi.get(path, locale).then((r) => r.data),
    enabled: !!path && !!locale,
  });
}

export function useUpsertSeo() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: SeoUpsert) => seoApi.upsert(data).then((r) => r.data),
    onSuccess: (_d, v) => qc.invalidateQueries({ queryKey: ["seo", v.path, v.locale] }),
  });
}
